import { Box } from '@mui/material'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import * as React from 'react'
import { useAuth } from 'react-oidc-context'
import { BottomAppNavigation } from '@/features/layout/components/BottomAppNavigation'
import { TopAppNavigation } from '@/features/layout/components/TopAppNavigation'
import { lazyLoad } from '@/helper/lazyLoad'

const Layout: React.FC<React.PropsWithChildren<{ isAdmin: boolean }>> = ({
    children,
    isAdmin,
}) => (
    <div style={{ height: '100dvh', overflow: 'auto' }}>
        <Box
            sx={{
                marginLeft: {
                    xxl: 'calc((100% - 60%) / 2)',
                    xl: 'calc((100% - 75%) / 2)',
                    lg: 'calc((100% - 80%) / 2)',
                    xs: 0,
                },
                width: {
                    xxl: '60%',
                    xl: '75%',
                    lg: '80%',
                    xs: '100%',
                },
            }}
        >
            <TopAppNavigation isAdmin={isAdmin} />

            <Box
                component={'main'}
                sx={{
                    margin: 1,
                    marginTop: 0,
                    marginBottom: { xs: 8, sm: 1 },
                }}
            >
                {children}
            </Box>

            <BottomAppNavigation isAdmin={isAdmin} />
        </Box>
    </div>
)

const LazyOnboarding = lazyLoad(
    () => import('@/features/layout/components/Onboarding'),
    'Onboarding'
)

const RouteComponent: React.FC = () => {
    const { user } = useAuth()
    const isAdmin = user?.profile.role === 'Administrator'

    return (
        <Layout isAdmin={isAdmin}>
            <Outlet />

            <LazyOnboarding />
        </Layout>
    )
}

const PendingComponent: React.FC = () => {
    const { user } = useAuth()
    const isAdmin = user?.profile.role === 'Administrator'

    return <Layout isAdmin={isAdmin} />
}

export const Route = createFileRoute('/__base-layout')({
    component: RouteComponent,

    pendingComponent: PendingComponent,
})
